import { render, staticRenderFns } from "./casitem.vue?vue&type=template&id=918fec30&"
import script from "./casitem.vue?vue&type=script&lang=js&"
export * from "./casitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports